import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import RotationalSpeedConverter from '../components/tools/RotationalSpeedConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'RPM to Rad/s Converter | Rotational Speed Converter | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert rotational speed between RPM, RPS, radians per second, and degrees per second instantly. Free online RPM to rad/s converter with formulas, worked example, and adjustable precision.';

const RotationalSpeedConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="rotational-speed-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="RPM to Rad/s Converter"
        description="Convert rotational speed between RPM, RPS, Radians per Second, and Degrees per Second. Enter a value in any unit and every other unit updates in real time."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="rotational-speed-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <RotationalSpeedConverter />
          <ToolGuideCta guidePath="/tools/rpm-rad-converter/guide" toolName="RPM to Rad/s Converter" />
        </div>
      </section>
    </div>
  );
};

export default RotationalSpeedConverterPage;
